export const traceInfoDft = {
    traceEnabled: false,
    samplingRate: undefined,
    service: 'Jaeger/Zipkin',
    address: '',
};
